import {Icon20MessageOutline} from "@vkontakte/icons";
import {Button} from "@vkontakte/vkui";
import React from "react";
import bridge from "@vkontakte/vk-bridge";
import {useSnackbar} from "../../context/SnackbarContext";

export const InviteButton = () => {
    const {showSuccessSnackbar, showErrorSnackbar} = useSnackbar();

    const inviteButtonHandler = () => {
        bridge.send('VKWebAppShare', {})
            .then((data) => {
                if (data.result) {
                    showSuccessSnackbar("Приглашение отправлено!");
                }
            })
            .catch((error) => {
                // 10007 is user cancel, 4 is permission denied. Don't show error for these.
                if (error.error_data?.error_code !== 10007 && error.error_data?.error_code !== 4) {
                    showErrorSnackbar("Не удалось отправить приглашение");
                }
                console.log("VKWebAppShare err:", error);
            });
    }

    return (
        <Button
            appearance={'overlay'}
            className={"app-btn-primary rounded border-solid border-2"}
            size={"m"}
            before={<Icon20MessageOutline/>}
            onClick={inviteButtonHandler}>
            Пригласить друга
        </Button>
    );
};
